export default __webpack_public_path__ + "static/media/sell-image6.9ceb2715.png";